/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pricing_Feature_ProfilesInputs */



/**
* | output |
* | --- |
* | "Member profiles and leaderboards" |
*
* @param {Pricing_Feature_ProfilesInputs} inputs
* @param {{ locale?: "en" | "ru" }} options
* @returns {LocalizedString}
*/
export const pricing_feature_profiles = /** @type {((inputs?: Pricing_Feature_ProfilesInputs, options?: { locale?: "en" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pricing_Feature_ProfilesInputs, { locale?: "en" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ru") return /** @type {LocalizedString} */ ("Профили участников и таблицы лидеров")
	return /** @type {LocalizedString} */ ("Member profiles and leaderboards")
});